import { ChevronRight } from '@mui/icons-material'
import classNames from 'classnames'
import { TAppealInList, TAppealsList, AppealsType } from 'feature/appeals/type'
import { Collapse } from 'ui'
import { OrderMiniCard } from 'widget/OrderMiniCard/OrderMiniCard'

import style from './AppealsList.module.scss'

type AppealsListProps = {
  title: AppealsType
  isExpanded: boolean
  onClick: (isExpanded: boolean) => void
  orderList: TAppealsList
}

// список заявок
export function AppealsList({
  title,
  onClick,
  isExpanded,
  orderList,
}: AppealsListProps) {
  const handleClick = () => {
    onClick(!isExpanded)
  }

  return (
    <>
      <div className={style.appealsCollapse}>
        <div
          onClick={handleClick}
          className={style.expandMore}
          data-testid={`appeals-section-${title}`}
        >
          <span className='h1'>{title}</span>
          <ChevronRight
            className={classNames(
              style.chevron,
              isExpanded && style.chevronActive,
            )}
            color='primary'
          />
        </div>

        <Collapse in={isExpanded} timeout='auto' unmountOnExit>
          <div className={style.collapseList}>
            {orderList.map((item: TAppealInList) => (
              <OrderMiniCard key={item.uid + +item.orderId} appeal={item} />
            ))}
          </div>
        </Collapse>
      </div>
    </>
  )
}
